import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'document-letter-number',
    template: `<covance-textfield 
        [label]="label" 
        [control]="control"
        [maxBytesCount]="maxBytesCount">
    </covance-textfield>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentLetterNumberComponent {
    @Input()
    public control: FormControl;

    public label = 'Letter Number';
    public maxBytesCount = 25;
}
